// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index.js'

//storeをインポートする
import store from './store/index.js'

import './registerServiceWorker'
import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad)
Vue.config.productionTip = false

const createApp = async () => {
  await store.dispatch('auth/currentUser')
  /* eslint-disable no-new */
  new Vue({
    router,
    store,  //storeを読み込む
    render: h => h(App)
  }).$mount('#app')
}

createApp()
